// src/app/core/mainPage/components/NewsSection.tsx
import { useRef, useEffect } from 'react';
import { useTranslation } from '@/app/core/ui/theme/LanguageProvider';
import { NewsCard } from './NewsCard';
import { newsItems } from './configNews/news';

interface NewsSectionProps {
  onNewsClick: (item: typeof newsItems[0]) => void;
}

export const NewsSection = ({ onNewsClick }: NewsSectionProps) => {
  const { t } = useTranslation();
  const scrollRef = useRef<HTMLDivElement>(null);

  const sortedNews = [...newsItems].sort((a, b) => b.id.localeCompare(a.id));

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    const handleWheel = (e: WheelEvent) => {
      e.preventDefault();
      el.scrollLeft += e.deltaY;
    };
    el.addEventListener('wheel', handleWheel, { passive: false });
    return () => el.removeEventListener('wheel', handleWheel);
  }, []);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollLeft = 0;
    }
  }, []);

  return (
    <section className="px-4 py-6">
      <h2 className="text-xl font-bold text-center text-foreground mb-4">{t('newsTitle')}</h2>
      {sortedNews.length === 0 ? (
        <p className="text-sm text-muted-foreground">{t('noNews')}</p>
      ) : (
        <div
          ref={scrollRef}
          className="flex overflow-x-auto gap-3 pb-2 scrollbar-hide snap-x snap-mandatory"
        >
          {sortedNews.map((item) => (
            <div key={item.id} className="snap-center flex-shrink-0 w-[calc(100vw-64px)] max-w-sm">
              <NewsCard
                item={item}
                onClick={() => onNewsClick(item)}
              />
            </div>
          ))}
          <div className="flex-shrink-0 w-4" />
        </div>
      )}
    </section>
  );
};